import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableHead,
  Tooltip,
} from "@mui/material";
import {
  OutlinedIconFab,
  StyledTableCellHistory,
  StyledTableContainer,
  StyledTableRowHistory,
} from "../StyledComponents";
import Icon from "../Utils/Icons";

export const ChiefComplaintTable = ({
  data,
  activeSection,
  handleEditRow = () => {},
  handleDeleteRow = () => {},
}) => {
  if (!data || data.length === 0) return null;

  return (
    <>
      {data.length > 0 && (
        <Grid item xs={12}>
          <StyledTableContainer
            component={Paper}
            // sx={{
            //   margin: "10px 5px",
            //   border: "1px solid #176BAD",
            //   overflowX: "auto",
            //   width: "100%",
            // }}
          >
            <Table sx={{ minWidth: 500 }}>
              <TableHead>
                <StyledTableRowHistory>
                  <StyledTableCellHistory>
                    Condition Name
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>
                    Clinical Status
                  </StyledTableCellHistory>
                  <StyledTableCellHistory>Duration</StyledTableCellHistory>
                  {/* <StyledTableCellHistory>Start Date</StyledTableCellHistory> */}
                  {/* <StyledTableCellHistory>End Date</StyledTableCellHistory> */}
                  <StyledTableCellHistory>
                    Clinical Notes
                  </StyledTableCellHistory>
                  {activeSection && (
                    <StyledTableCellHistory>Actions</StyledTableCellHistory>
                  )}
                </StyledTableRowHistory>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <StyledTableRowHistory key={rowIndex}>
                    <StyledTableCellHistory>
                      {row.condition}
                      {row?.source === "voice" && !row.id && (
                        <Tooltip title="Machine-interpreted text — please verify before confirming">
                          <span className="missing-id-warning">⚠️</span>
                        </Tooltip>
                      )}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.clinical_status_description}
                    </StyledTableCellHistory>
                    <StyledTableCellHistory>
                      {row.duration
                        ? row.durationType
                          ? `${row.duration} ${row.durationType}`
                          : row.duration
                        : "-"}
                    </StyledTableCellHistory>
                    {/* <StyledTableCellHistory>
                        {row.onset_datetime
                          ? dayjs(row.onset_datetime).format("DD-MM-YYYY")
                          : "-"}
                      </StyledTableCellHistory> */}
                    {/* <StyledTableCellHistory>
                        {row.abatement_datetime
                          ? dayjs(row.abatement_datetime).format("DD-MM-YYYY")
                          : "-"}
                      </StyledTableCellHistory> */}
                    <StyledTableCellHistory>
                      {row.clinical_note.length > 0 ? row.clinical_note : "-"}
                    </StyledTableCellHistory>
                    {activeSection && (
                      <StyledTableCellHistory sx={{ display: "flex" }}>
                        {/* <EditIcon onClick={() => handleEditRow(rowIndex)} /> */}
                        <OutlinedIconFab
                          onClick={() => handleEditRow(rowIndex)}
                          sx={{ marginRight: 1 }}
                        >
                          <Icon name="editInTable" size={32} />
                        </OutlinedIconFab>

                        {/* <DeleteIcon
                            onClick={() => handleDeleteRow(rowIndex)}
                          /> */}
                        <OutlinedIconFab
                          onClick={() => handleDeleteRow(rowIndex)}
                        >
                          <Icon name="deleteInTable" size={32} />
                        </OutlinedIconFab>
                      </StyledTableCellHistory>
                    )}
                  </StyledTableRowHistory>
                ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Grid>
      )}
    </>
  );
};
